// Shared helpers for reading consultation-level fields. Used by both the
// member dashboard (priority resolver fallback) and the Plan tab (section
// bucketing) so a single source of truth decides whether a physician
// recommendation is still actionable.

// A `physicianRecommendation` payload is considered "pending" until the
// member has explicitly accepted or declined it. After that the backend
// keeps the field on the consultation but stamps a marker — accept every
// signal the backend has shipped so the moment any of them are set, the
// recommendation card disappears.
//
// Resolved-state markers the backend has shipped over time:
//   • acceptedAt / declinedAt / decidedAt / resolvedAt   (timestamps)
//   • status: "accepted" | "declined" | "resolved"        (post Feb 2026)
//   • decision / state (legacy aliases)
//   • memberDecision: "accepted" | "declined"             (new — Mar 2026)
//   • memberDecidedAt                                     (new — Mar 2026)
export function isPendingRecommendation(rec) {
  if (!rec) return false;
  if (
    rec.acceptedAt ||
    rec.declinedAt ||
    rec.decidedAt ||
    rec.resolvedAt ||
    rec.memberDecidedAt
  ) return false;
  const status = String(rec.status || rec.decision || rec.state || rec.memberDecision || "").toLowerCase();
  if (["accepted", "declined", "resolved", "decided", "complete", "completed"].includes(status)) return false;
  return true;
}

// Convenience — does the consultation document carry a still-pending
// physician recommendation? Used by the dashboard's priority resolver
// override so we only force the recommendation hero when the member
// actually has a decision to make.
export function hasPendingRecommendation(consultation) {
  return isPendingRecommendation(consultation?.physicianRecommendation);
}
